import React, { FC, useMemo } from 'react';
import moment from 'moment';

import { IFilterType } from '../../../../../../types/ProfileTypes';
import { VDateTimePickerStyled } from '../styled';

type DateTimeFilerType = {
  filter: IFilterType;
  onChange: (value: any) => void;
  disabled: boolean;
  showLabel?: boolean;
  disableContext: boolean;
  tipLabel?: string;
  minimal?: boolean;
  type: 'DATE' | 'TIME' | 'DATETIME';
};

const DateTimeFilter: FC<DateTimeFilerType> = ({
  filter,
  onChange,
  disabled,
  type,
  showLabel,
  disableContext,
  tipLabel,
  minimal
}) => {
  const value = useMemo(() => {
    if (!!filter.value) {
      return moment(filter.value).toDate();
    }
    return null;
  }, [filter.value]);

  const format = useMemo(
    () => (type === 'TIME' ? 'HH:mm' : type === 'DATETIME' ? 'MM/DD/YYYY hh:mm a' : 'MM/DD/YYYY'),
    [type]
  );

  return (
    <VDateTimePickerStyled
      dateType={type}
      id="startDate"
      inline
      margin={'0'}
      layer={{
        inputWidth: showLabel ? 8 : 12,
        labelOrientation: 'start',
        labelWidth: showLabel ? 4 : undefined
      }}
      disabled={disabled || disableContext}
      noLabel={!showLabel}
      tipLabel={tipLabel && !showLabel ? tipLabel : ''}
      fill
      format={format}
      value={value || null}
      closeOnSelection={false}
      label={showLabel ? filter.label : ''}
      onChange={(value: any) => {
        if (onChange) {
          if (value) {
            onChange(moment.utc(value).toDate());
          } else {
            onChange(value);
          }
        }
      }}
      minimal={minimal}
      precision={filter.timePrecision}
      useAmPm={filter.useAmPm || type === 'DATETIME'}
      type={type}
      canClearSelection={filter.canClearSelection}
    />
  );
};

export default DateTimeFilter;
